import React from 'react'
import Footer from '../footer/Footer'
import s from './ItineraryHomeMainContent.less'
import ItineraryMainContent from './seo/ItineraryHPText'
import { AdMobileBannerItineraryHP } from '../advertising/InlineMobileAdBanner'
import { AdDesktopItineraryHP } from '../advertising/InlineDesktopAdBanner'
import Faq from '../seo/FAQ/Faq'
import AutoPromoGE from '../autopromo/AutoPromoGE'
import FavoritesPushHpIti from '../UserAccount/Favorites/FavoritesPushHpIti'

const ItineraryHomeMainContent = () => (
  <>
    <div className={s.ItineraryHomeMainContent}>
      <FavoritesPushHpIti />
      <div>
        <AdDesktopItineraryHP />
        <AdMobileBannerItineraryHP />
      </div>
      <AutoPromoGE />
      <ItineraryMainContent />
      <Faq />
    </div>
    <Footer />
  </>
)

export default ItineraryHomeMainContent
